<template>
  <b-modal
    size="lg"
    hide-header
    hide-footer
    body-class="p-0"
    centered
    v-model="isVisible"
    @hidden="onHidden"
    :modal-class="isAbove ? 'modal-on-top' : ''"
    :backdrop-class="isAbove ? 'backdrop-on-top' : ''"
  >
    <div class="popup-modal-content position-relative w-100 bg-white rounded overflow-hidden">
      <!-- Close Button Overlay -->
      <img
        src="@/assets/img/icon/cancel.png"
        class="close-btn d-inline-block p-2 rounded-3 bg-back cursor-pointer position-absolute"
        width="33"
        @click="closeModal"
      />

      <!-- Image Section -->
      <div v-if="imageUrl" class="image-wrapper w-100">
        <img :src="imageUrl" class="img-fluid w-100 d-block" alt="Popup Image" />
      </div>

      <!-- Text Section -->
      <div v-if="title || description" class="text-wrapper p-5 text-center">
        <h4 v-if="title" class="mb-3">{{ title }}</h4>
        <p v-if="description" class="mb-0 body-1-3" v-html="description"></p>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'PopupModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    imageUrl: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    isAbove: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    closeModal() {
      this.isVisible = false;
    },
    onHidden() {
      this.$emit('hidden');
    }
  }
}
</script>

<style scoped>
.close-btn {
  z-index: 1051;
  right: 15px;
  top: 15px;
}
/* Ensure the modal content stays clean and takes full width */
.popup-modal-content {
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}
</style>

<style>
/*
  Ensures both the modal and its backdrop have a higher z-index when isAbove is true.
  By default b-modal has z-index 1050 (backdrop 1040).
*/
.modal-on-top {
  z-index: 1100 !important;
}
.backdrop-on-top {
  z-index: 1090 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/PopupModal.vue